import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  userData: any;

  constructor() { }

  storeUserInfo(data) {
    this.userData = data
  }

  get userInfo() {
    return this.userData
  }
}
